// Environment configuration for the widget
// This can be overridden at runtime when embedding the widget

export interface WidgetConfig {
  apiUrl: string;
  chatEndpoint: string;
  documentEndpoint: string;
  mode?: 'embedded' | 'standalone';
}

// Default configuration from environment variables
const defaultConfig: WidgetConfig = {
  apiUrl: process.env.NEXT_PUBLIC_API_URL || 'http://localhost:3007',
  chatEndpoint: process.env.NEXT_PUBLIC_CHAT_ENDPOINT || '/api/v1/assistant/chat',
  documentEndpoint: process.env.NEXT_PUBLIC_DOCUMENT_ENDPOINT || '/api/v1/documents',
  mode: (process.env.NEXT_PUBLIC_WIDGET_MODE as 'embedded' | 'standalone') || 'standalone',
};

// Global widget configuration that can be set at runtime
let runtimeConfig: Partial<WidgetConfig> = {};

// Initialize widget with custom configuration
export function initializeWidget(config: Partial<WidgetConfig>) {
  runtimeConfig = { ...config };
}

// Get current configuration
export function getConfig(): WidgetConfig {
  return {
    ...defaultConfig,
    ...runtimeConfig,
  };
}

// Get full API URLs
export function getApiUrl(endpoint: string): string {
  const config = getConfig();
  const baseUrl = config.apiUrl.replace(/\/$/, ''); // Remove trailing slash
  const path = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${baseUrl}${path}`;
}

export function getChatUrl(): string {
  const config = getConfig();
  return getApiUrl(config.chatEndpoint);
}

export function getDocumentUrl(documentId?: string): string {
  const config = getConfig();
  const baseUrl = getApiUrl(config.documentEndpoint);
  return documentId ? `${baseUrl}?id=${documentId}` : baseUrl;
}
